import { iHome, iShoppingCart, iFileText } from '@hover/icons';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import LockIcon from '../assets/svgs/LockIcon';

const ListData = [
  {
    id: 0,
    title: 'TOTAL PRIVACY',
    body: 'You own your data and photos, and you can remove access for any contractor or company, any time. ',
    icon: LockIcon,
    desktopImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectFit="contain"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
    mobileImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        objectFit="contain"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
  },
  {
    id: 1,
    title: 'VISUALIZE',
    body: 'No need to just guess what the finished product will look like—see it with your own eyes using our interactive, 3D design tools.',
    icon: iHome,
    desktopImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_group.png"
        objectFit="contain"
      />
    ),
    mobileImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_group_mobile.png"
        objectFit="contain"
      />
    ),
  },
  {
    id: 2,
    title: 'BETTER ESTIMATES',
    body: 'Fast, accurate measurements from your photos means a fast, more accurate estimate and fewer cost “uh-oh’s” later.',
    icon: iFileText,
    desktopImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="take photo"
        objectFit="contain"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
    mobileImage: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="take photo"
        objectFit="contain"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
  },
  {
    id: 3,
    title: 'TRANSPARENCY',
    body: 'Understand and trust your contractor’s proposal—no hidden costs or guesswork.',
    icon: iShoppingCart,
    desktopImage: null,
    mobileImage: null,
  },
];

export default ListData;
